import React from "react";
import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative w-full bg-[#1A1A18] text-[#F7F5F0] pt-24 pb-10 overflow-hidden"
    >
      <div className="mx-auto max-w-[1440px] px-6 sm:px-10">
        {/* Top rule */}
        <div className="flex items-baseline justify-between border-b border-[#F7F5F0]/15 pb-6">
          <span className="font-sans-ui text-[11px] uppercase tracking-[0.3em] text-[#F7F5F0]/50">
            (Colophon)
          </span>
          <span className="font-serif-display italic text-[#F7F5F0]/60">est. California</span>
        </div>

        {/* Contact grid */}
        <div className="mt-16 grid grid-cols-12 gap-10">
          <div className="col-span-12 md:col-span-5">
            <p className="font-sans-ui text-[11px] uppercase tracking-[0.3em] text-[#F7F5F0]/60">
              Reach out
            </p>
            <a
              href="tel:2096706799"
              data-testid="footer-phone"
              className="mt-6 block font-serif-display text-5xl sm:text-6xl italic text-[#F7F5F0] link-under"
            >
              209.670.6799
            </a>
            <a
              href="mailto:hello@dlgcounseling.com"
              data-testid="footer-email"
              className="mt-4 inline-block font-sans-ui text-[15px] text-[#F7F5F0]/80 link-under"
            >
              hello@dlgcounseling.com
            </a>
          </div>

          <div className="col-span-6 md:col-span-3">
            <p className="font-sans-ui text-[11px] uppercase tracking-[0.3em] text-[#F7F5F0]/60">
              Explore
            </p>
            <ul className="mt-6 space-y-3 font-sans-ui text-[14px]">
              {["Approach", "Services", "About", "FAQ", "Consultation"].map((l) => (
                <li key={l}>
                  <a
                    href={`#${l.toLowerCase() === "consultation" ? "book" : l.toLowerCase()}`}
                    className="link-under text-[#F7F5F0]/85"
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-6 md:col-span-4">
            <p className="font-sans-ui text-[11px] uppercase tracking-[0.3em] text-[#F7F5F0]/60">
              Practice
            </p>
            <ul className="mt-6 space-y-3 font-sans-ui text-[14px] text-[#F7F5F0]/85">
              <li>DLG Counseling &amp; Consulting, MFT</li>
              <li>LMFT #122546 — California</li>
              <li>California residents — telehealth only</li>
              <li>HIPAA-compliant · confidential</li>
              <li>Monday–Friday, evenings by request</li>
            </ul>
          </div>
        </div>

        {/* Giant logotype */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 1.1, ease }}
          className="mt-20 border-t border-[#F7F5F0]/15 pt-12"
        >
          <h3
            data-testid="footer-logotype"
            className="font-serif-display font-light italic tracking-tighter leading-[0.85] text-[26vw] sm:text-[22vw] lg:text-[18vw] text-[#F7F5F0]"
          >
            DLG&nbsp;MFT
          </h3>
        </motion.div>

        {/* Disclosure */}
        <div className="mt-10 grid grid-cols-12 gap-6 border-t border-[#F7F5F0]/15 pt-8">
          <p className="col-span-12 md:col-span-8 font-sans-ui text-[11px] leading-relaxed text-[#F7F5F0]/55">
            © {new Date().getFullYear()} DLG Counseling &amp; Consulting, MFT — LMFT #122546.
            All rights reserved. This site is for informational purposes and does not constitute
            clinical advice. If you are in crisis, please call or text{" "}
            <span className="text-[#F7F5F0]">988</span> (Suicide &amp; Crisis Lifeline) or go to
            your nearest emergency room.
          </p>
          <p className="col-span-12 md:col-span-4 md:text-right font-sans-ui text-[11px] uppercase tracking-[0.28em] text-[#F7F5F0]/55">
            Designed with care — 2025
          </p>
        </div>
      </div>
    </footer>
  );
}
